export const servicesData = [
  {
    serviceName: "Development",
    desc: "SMC always strives to reach the most suitable solutions for customer requirements through research and development of new constructive ideas related to the Grid connected PV systems or isolated from it in addition to solar heating systems.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path
          d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path d="M 0 0 L 32 0 L 32 32 L 0 32 Z" fill="transparent"></path>
      </svg>
    ),
  },

  {
    serviceName: "Desing",
    desc: "Successful investments always and ever start through the appropriate planning, arranging and drawing a road map, that SMC starts in its first steps by developing the most appropriate design for the needs of its customers according to the best international and local standards.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path
          d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path d="M 0 0 L 32 0 L 32 32 L 0 32 Z" fill="transparent"></path>
      </svg>
    ),
  },

  {
    serviceName: "Installation",
    desc: "And because the implementation of dreams and big plans requires a strong and qualified team at the highest level of efficiency and readiness to carry out the work, SMC always maintains the high technical and professional spirit of its team of technicians and engineers responsible for the implementation of these projects.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path
          d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path d="M 0 0 L 32 0 L 32 32 L 0 32 Z" fill="transparent"></path>
      </svg>
    ),
  },

  {
    serviceName: "Evalution",
    desc: "Monitoring the progress of the production process in power plants and continuous evaluation of performance helps maintain the safety of the various parts of the plant, ensure its efficiency, and prevent business disruption by predicting future problems and pitfalls and directing the maintenance team to intervene and correct the situation at the appropriate times.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path
          d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path d="M 0 0 L 32 0 L 32 32 L 0 32 Z" fill="transparent"></path>
      </svg>
    ),
  },

  {
    serviceName: "Consulting",
    desc: "The first and always the most important step in the journey of searching for new and renewable energy solutions is to obtain the appropriate consultations through a highly skilled and experienced team, which SMC provides to its clients.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="29">
        <path
          d="M 27.139 0.885 L 8.779 0.885 C 7.729 0.885 6.877 1.736 6.877 2.785 L 6.877 7.913 L 20.262 7.913 C 22.359 7.913 24.065 9.617 24.065 11.712 L 24.065 16.296 L 27.139 16.296 C 28.19 16.296 29.041 15.446 29.041 14.397 L 29.041 2.785 C 29.041 1.736 28.19 0.885 27.139 0.885 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 20.262 9.812 L 1.902 9.812 C 0.851 9.812 0 10.663 0 11.712 L 0 23.324 C 0 24.373 0.851 25.224 1.902 25.224 L 7.755 25.224 L 9.627 27.447 C 9.988 27.876 10.521 28.124 11.082 28.124 C 11.643 28.124 12.176 27.876 12.537 27.447 L 14.409 25.224 L 20.262 25.224 C 21.312 25.224 22.164 24.373 22.164 23.324 L 22.164 11.712 C 22.164 10.663 21.312 9.812 20.262 9.812 Z M 9.402 20.4 L 4.447 20.4 C 3.922 20.4 3.497 19.975 3.497 19.451 C 3.497 18.926 3.922 18.501 4.447 18.501 L 9.402 18.501 C 9.927 18.501 10.353 18.926 10.353 19.451 C 10.353 19.975 9.927 20.4 9.402 20.4 Z M 17.211 16.472 L 4.447 16.472 C 3.922 16.472 3.497 16.047 3.497 15.523 C 3.497 14.998 3.922 14.573 4.447 14.573 L 17.211 14.573 C 17.736 14.573 18.162 14.998 18.162 15.523 C 18.162 16.047 17.736 16.472 17.211 16.472 Z"
          fill="rgb(59, 59, 59)"
        ></path>
      </svg>
    ),
  },

  {
    serviceName: "Procurement",
    desc: "SMC is keen to provide all its projects and clients with a set of the best products that conform to standard international and local specifications in order to ensure the right quality, the right price and maintain high levels of continuity and reliability.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
        <path
          d="M 8 4 L 8 8 L 4 8 L 4 4 L 8 4 M 2 2 L 2 10 L 10 10 L 10 2 Z M 18 7 L 18 11 L 14 11 L 14 7 L 18 7 M 12 5 L 12 13 L 20 13 L 20 5 Z M 8 16 L 8 20 L 4 20 L 4 16 L 8 16 M 2 14 L 2 22 L 10 22 L 10 14 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 22 10 L 22 16 L 16 16 L 16 22 L 10 22 L 10 30 L 30 30 L 30 10 Z M 18 18 L 22 18 L 22 22 L 18 22 Z M 16 28 L 12 28 L 12 24 L 16 24 Z M 22 28 L 18 28 L 18 24 L 22 24 Z M 28 28 L 24 28 L 24 24 L 28 24 Z M 28 22 L 24 22 L 24 18 L 28 18 Z M 24 16 L 24 12 L 28 12 L 28 16 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path d="M 0 0 L 32 0 L 32 32 L 0 32 Z" fill="transparent"></path>
      </svg>
    ),
  },

  {
    serviceName: "Maintenance",
    desc: "Maintaining the safety and life span of equipment and components through preventive and corrective maintenance is one of the most important sensitive points that SMC seeks to maintain between it and its customers.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
        <path
          d="M 22.971 11.657 L 22.971 1.6 L 7.886 1.6 L 7.886 16.686 L 16.686 16.686 L 16.686 7.886 L 1.6 7.886 L 1.6 22.971 L 11.657 22.971 M 16.686 28 L 24.229 20.457 M 25.486 16.686 C 24.097 16.686 22.971 17.811 22.971 19.2 C 22.971 20.589 24.097 21.714 25.486 21.714 C 26.874 21.714 28 20.589 28 19.2"
          fill="transparent"
          strokeWidth="3"
          stroke="rgb(59, 59, 59)"
          strokeMiterlimit="10"
        ></path>
      </svg>
    ),
  },

  {
    serviceName: "Training",
    desc: "Providing strong training opportunities is one of the main tasks that SMC maintains in order to train customers to deal with power plants owned by them, follow up their work and evaluate their performance, in addition to raising the technical and professional level of the technical and engineering sector by providing appropriate training opportunities for engineers and technicians on a wide geographical range through the branches of SMC Academy in cooperation with a group of the most powerful engineering companies and platforms in the Egyptian market.",
    svgElem: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
        <path
          d="M 29.063 0.347 L 13.103 0.347 C 12.572 0.347 12.142 0.778 12.142 1.308 L 12.142 8.086 L 12.837 7.274 C 13.167 6.888 13.601 6.65 14.063 6.551 L 14.063 2.269 L 28.102 2.269 L 28.102 14.817 L 14.063 14.817 L 14.063 12.716 L 13.631 13.222 C 13.253 13.663 12.719 13.937 12.142 13.99 L 12.142 15.777 C 12.142 16.307 12.572 16.738 13.103 16.738 L 18.286 16.738 L 15.653 28.693 C 15.535 29.229 15.874 29.76 16.41 29.878 C 16.942 29.995 17.477 29.657 17.593 29.121 L 20.321 16.738 L 21.906 16.738 L 24.634 29.121 C 24.736 29.585 25.147 29.901 25.603 29.901 C 25.676 29.901 25.748 29.893 25.818 29.878 C 26.355 29.76 26.694 29.229 26.575 28.693 L 23.941 16.738 L 29.063 16.738 C 29.593 16.738 30.023 16.307 30.023 15.777 L 30.023 1.308 C 30.023 0.778 29.593 0.347 29.063 0.347 Z"
          fill="rgb(59, 59, 59)"
        ></path>
        <path
          d="M 21.434 5.958 C 21.358 5.767 21.143 5.674 20.953 5.749 L 15.294 7.746 C 14.775 7.344 14.026 7.416 13.592 7.92 L 11.797 10.017 L 10.205 8.652 C 10.215 8.765 10.239 8.874 10.239 8.99 L 10.239 11.952 L 11.125 12.711 C 11.651 13.161 12.437 13.092 12.876 12.576 L 15.014 10.077 L 16.738 9.068 L 21.275 6.414 C 21.433 6.322 21.501 6.128 21.434 5.958 Z M 6.744 6.489 L 5.678 6.489 C 4.861 6.489 4.143 6.886 3.687 7.491 L 0.414 10.504 C -0.096 10.959 -0.142 11.746 0.317 12.259 L 2.987 15.239 C 3.443 15.749 4.231 15.794 4.741 15.336 C 5.252 14.878 5.295 14.093 4.837 13.582 L 2.996 11.527 L 5.611 9.187 L 4.088 11.256 L 5.578 12.919 C 6.401 13.839 6.323 15.252 5.404 16.076 C 4.776 16.639 3.92 16.771 3.177 16.511 C 3.177 16.511 3.188 22.257 3.188 28.411 C 3.188 29.234 3.856 29.901 4.679 29.901 C 5.501 29.901 6.169 29.234 6.169 28.411 L 6.169 19.529 L 7.163 19.529 L 7.163 28.411 C 7.163 28.84 7.043 29.238 6.852 29.59 C 7.102 29.783 7.413 29.901 7.753 29.901 C 8.576 29.901 9.243 29.234 9.243 28.411 C 9.243 22.259 9.245 24.838 9.245 8.99 C 9.245 7.609 8.126 6.489 6.744 6.489 Z M 4.883 5.595 C 5.281 5.802 5.729 5.931 6.209 5.931 C 6.691 5.931 7.138 5.802 7.538 5.595 C 8.471 5.111 9.114 4.149 9.114 3.026 C 9.114 1.422 7.813 0.122 6.209 0.122 C 4.605 0.122 3.305 1.422 3.305 3.026 C 3.305 4.15 3.949 5.112 4.883 5.595 Z"
          fill="rgb(59, 59, 59)"
        ></path>
      </svg>
    ),
    seeAcadmey: "See Academy",
  },
];
